<template>
<v-card :class="getCSSClass()" :color="`${color} ${color.includes('lighten') || color.includes('darken')? '':'lighten-1'}`">
  <v-row>
    <v-col cols="12">
      <slot name="head" />
    </v-col>
  </v-row>
  <v-row>
    <v-col cols="12">
      <slot name="body"/>
    </v-col>
  </v-row>
</v-card>
</template>

<script>
export default {
  name: 'WorkPackageLarge',
  props: ['color'],
  methods: {
    getCSSClass(){
      if (this.$vuetify.breakpoint.smAndDown) {
        return 'workpackage-large';
      } else {
        return 'workpackage-large pa-2';
      }
    }
  }
}
</script>
<style lang="css" scoped>
.workpackage-large {
  height: 98%;
  width: 99%;
  font-size: 14px;
  margin: 5px 5px 5px 5px;
  overflow-y: auto;
  overflow-x: hidden;
  will-change: transform;
  padding-top: 0px;
}
</style>
